import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd } from "@/lib/seo";
import { FAQS_INTEGRATIONS } from "@/lib/service-content/faqs/integrations";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/integraciones-shopify";

export const Route = createFileRoute("/es/integraciones-shopify")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Integraciones Shopify: ERP, OMS, PIM, WMS y 3PL · Shugert",
    description: "Arquitectura de integraciones Shopify con contratos de datos, retries, conciliación y ownership operativo. Build Custom o Replatform desde $5,000 USD.",
    path: PATH,
    altPath: alternatePath(PATH, "en"),
    ogImage: "/og-integrations-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Servicios", path: "/es/servicios" }, { name: "Integraciones Shopify", path: PATH }]),
      faqJsonLd(FAQS_INTEGRATIONS.es),
      serviceJsonLd({
        name: "Integraciones Shopify",
        description: "Integraciones Shopify para ERP, OMS, PIM, WMS, 3PL y finanzas con contratos de datos, manejo de fallos, monitoreo y handoff.",
        path: PATH,
        serviceType: "Integraciones Shopify",
        minPrice: 5000,
        unit: "PROJECT",
        deliverables: ["Inventario de sistemas", "Contrato de datos y ownership", "Diseño de fallos y recuperación", "Pipeline en staging", "Monitoreo, conciliación y runbook"],
        locale: "es",
      }),
    ],
  }),
});
